
import { useCallback, useState, useEffect } from "react";
import "../styles/nimbly2.css";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useProject } from '../contexts/ProjectContext';
import { useEnvironmentConfigContext } from '../contexts/EnvironmentConfigContext';
import loadinggif from "../assets/loading.gif";

const ExpandedMeter = ({ item }) => {
    const { selectedProject, GCP_Project, Dataset_ID } = useProject();
    const { environmentConfig } = useEnvironmentConfigContext();
    const [loading, setLoading] = useState(false);
    const [meter, setMeter] = useState(null);

    const itemGlobalID = item?.info?.GlobalID;

    const populatePolePopupData = useCallback(() => {
        setLoading(true);
        fetch(`${process.env.REACT_APP_WEB_API_URL}/api-common/poles/MeterLookup`, {
            method: 'POST',
            headers: {
                'frontendenvironmentconfig': environmentConfig,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                Dataset_ID: Dataset_ID,
                GCP_Project: GCP_Project,
                Project: selectedProject,
                GlobalID: item.info.GlobalID,
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                var meter = data;    

                setMeter(meter);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [selectedProject, GCP_Project, Dataset_ID, environmentConfig, item]);

    useEffect(() => {
        if (selectedProject && GCP_Project && Dataset_ID && itemGlobalID) {
            populatePolePopupData();
        }
    }, [selectedProject, GCP_Project, Dataset_ID, itemGlobalID, populatePolePopupData]);


    return (
        <div className="nimbly-pole-popup-wrapper">
            <header className="nimbly-pole-popup-header">
                {"Meter Structure ID: "+item.info["StructureID"]}
            </header>
            <div className='nimbly-pole-popup-info-container'>
                {loading ? <div className='nimbly-pole-popup-info-loading-img'><img className='nimbly2-map-loader-gif' src={loadinggif} alt="Loading..."/></div> 
                    : (meter == null ? "No Data"
                    : <div >
                <div className="nimbly-pole-popup-img-wrapper">
                    {/* Image Containers */}
                    {!(meter?.photosDict != null && Object.values(meter.photosDict).length > 0) ? 
                        <div> No Photos </div> : 
                        Object.values(meter?.photosDict)?.map((photo, x) => (
                            <div className="nimbly-pole-img-container-ug">
                                <a target="_blank" href={photo["Photo Path"]} rel="noreferrer"><img src={photo["Photo Path"]} alt="Pole" /></a>
                                {Object.keys(photo).filter(x => x === "Photo Name")?.map(photoField => (
                                    <GridLayoutItem><strong>{photoField}</strong>:{photo[photoField]}</GridLayoutItem>
                                )
                                )}
                            </div>
                    ))}
                </div>
                <div className="nimbly-pole-details-wrapper">
                    {!(meter?.fieldDict != null && Object.keys(meter?.fieldDict) != null) ? <div>
                        No Pole Data
                            </div>
                        : 
                        <>
                            <section className="nimbly-pole-details-section">
                                <GridLayout
                                    gap={{
                                        rows: 5,
                                        cols: 2,
                                    }}
                                    cols={[
                                        {
                                            width: "50%",
                                        },
                                        {
                                            width: "50%",
                                        }
                                    ]}
                                >
                                    <GridLayoutItem className="pulse-expand-title-ug" row={1} col={1} colSpan={2}>
                                        Meter Status
                                    </GridLayoutItem>
                                    <GridLayoutItem className="pulse-expand-title-ug-symbology" row={2} col={1} colSpan={2}>
                                        {meter?.fieldDict?.Symbology}
                                    </GridLayoutItem>
                                </GridLayout>
                            </section>
                            <section className="nimbly-pole-details-section">
                            <GridLayout gap={{rows: 20, cols: 2}} cols={[{width: "50%"}, {width: "50%"}]}>
                                <GridLayoutItem className="pulse-expand-title-ug" row={1} col={1} colSpan={2}>
                                    Meter Overview
                                </GridLayoutItem>
                                        <GridLayoutItem className="pulse-queryresult-expanded-detail-column-ug" row={2} col={1}>
                                            Structure ID
                                        </GridLayoutItem>
                                        <GridLayoutItem row={2} col={2}>
                                            {meter?.fieldDict["Structure ID"]}
                                        </GridLayoutItem>
                                        <GridLayoutItem className="pulse-queryresult-expanded-detail-column-ug-linebreak" row={2} col={1} colSpan={2} />
                            </GridLayout>
                        </section>
                        <section className="nimbly-pole-details-section">
                                <GridLayout gap={{rows: 20, cols: 2}} cols={[{width: "50%"}, {width: "50%"}]}>
                                    {Object.keys(meter?.fieldDict).filter(x => x !== "Symbology" && x !== "Structure ID" && x !== "Alternate Structure ID" && x !== "Feeder ID")?.map((fieldName, fieldIndex) => (
                                        <>
                                            <GridLayoutItem className="pulse-queryresult-expanded-detail-column" row={fieldIndex + 2} col={1}>
                                                {fieldName}
                                            </GridLayoutItem>
                                            <GridLayoutItem row={fieldIndex + 2} col={2}>
                                                {meter?.fieldDict[fieldName]}
                                            </GridLayoutItem>
                                            <GridLayoutItem className="pulse-queryresult-expanded-detail-column-ug-linebreak" row={fieldIndex + 2} col={1} colSpan={2}>
                                            </GridLayoutItem>
                                        </>
                                    ))}


                                </GridLayout>
                            </section>
                        </>
                        }
                </div>
                        </div>)}
            </div>
        </div>
        // <div>test</div>
    );
}

export default ExpandedMeter;